module.exports = __webpack_public_path__ + "static/media/B-BTN.cdd6a87c.png";